<div class="app-content" [attr.inert]="activeAlert() ? '' : null">
  <router-outlet />
</div>

@if (activeAlert(); as alert) {
  <cv-dialog
    title="Alert!"
    [message]="alert.message"
    [buttons]="alert.buttons"
    [maxPriority]="alert.maxPriority"
    (confirmed)="alert.confirm()"
  />
}
